import { render, staticRenderFns } from "./OwalLogo.vue?vue&type=template&id=50f5b712&scoped=true"
import script from "./OwalLogo.vue?vue&type=script&lang=js"
export * from "./OwalLogo.vue?vue&type=script&lang=js"
import style0 from "./OwalLogo.vue?vue&type=style&index=0&id=50f5b712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5b712",
  null
  
)

export default component.exports